// extracted by mini-css-extract-plugin
export default {"label":"RadioButton_label__jBAt0","input":"RadioButton_input__0-AfT","customButton":"RadioButton_customButton__ruM1K"};